import { render } from "./SignatureForm.vue?vue&type=template&id=7a85b30d&scoped=true"
import script from "./SignatureForm.vue?vue&type=script&lang=js"
export * from "./SignatureForm.vue?vue&type=script&lang=js"

import "./SignatureForm.vue?vue&type=style&index=0&id=7a85b30d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a85b30d"]])

export default __exports__